import { CheckIcon } from "@heroicons/react/outline";
import {
    DocumentReportIcon,
    InboxIcon,
    PencilAltIcon,
    TrashIcon,
    UsersIcon,
} from "@heroicons/react/outline";
import Promises from "./Promises";
import Listen from "./Listen";

export default () => {
    const people = [
        {
            name: "Roel - Personal Trainer Uden",
            role: "Gecertificeerd trainer die gespecialiseerd is in onderhouden van jouw resultaten.",
            imageUrl: "/assets/trainers/personal-trainer-roel-alt.jpg",
            imageUrlWebp:
                "/assets/trainers/webp/personal-trainer-roel-alt.webp",
        },
        {
            name: "Brayen - Personal Trainer Schijndel",
            role: "Gecertificeerd coach die gespecialiseerd is in het maken van effectieve training- en voedingsschema's.",
            imageUrl: "/assets/trainers/personal-trainer-brayen-alt.jpg",
            imageUrlWebp:
                "/assets/trainers/webp/personal-trainer-brayen-alt.webp",
        },
        {
            name: "Thierry - Personal Trainer Uden",
            role: "Gecertificeerd coach die gespecialiseerd is in de mentale transformaties van onze leden.",
            imageUrl: "/assets/trainers/personal-trainer-thierry-alt.jpg",
            imageUrlWebp:
                "/assets/trainers/webp/personal-trainer-thierry-alt.webp",
        },
        {
            name: "Casper - Personal Trainer Schijndel",
            role: "Gecertificeerd coach die gespecialiseerd is in spieropbouw en krachttoename.",
            imageUrl: "/assets/trainers/personal-trainer-casper-alt.jpg",
            imageUrlWebp:
                "/assets/trainers/webp/personal-trainer-casper-alt.webp",
        },
        {
            name: "Tim - Personal Trainer Uden",
            role: "Gespecialiseerd in spieropbouw en krachttoename.",
            imageUrl: "/assets/trainers/personal-trainer-tim.jpg",
            imageUrlWebp: "/assets/trainers/webp/personal-trainer-tim.webp",
        },
        {
            name: "Jori - Personal Trainer Uden",
            role: "Gespecialiseerd in spieropbouw en krachttoename.",
            imageUrl: "/assets/trainers/personal-trainer-jori.jpg",
            imageUrlWebp: "/assets/trainers/webp/personal-trainer-jori.webp",
        },
    ];

    const promises = [
        {
            name: "Verzekerd van resultaat",
            icon: InboxIcon,
        },
        {
            name: "Trainen in een ruimte met gelijkgestemden",
            icon: UsersIcon,
        },
        {
            name: "Onbeperkt nazorg",
            icon: TrashIcon,
        },
        {
            name: "365 dagen per jaar begeleiding",
            icon: PencilAltIcon,
        },
        {
            name: "100% tevredenheidsgarantie",
            icon: DocumentReportIcon,
        },
    ];

    return (
        <div className="relative xs:py-8 sm:py-8 md:py-16 lg:py-16">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-4xl mx-auto text-center">
                    <h2 className="block text-white mx-auto font-custom italic font-bold uppercase max-w-4xl xs:text-4xl sm:text-4xl md:text-4xl lg:text-5xl mt-8">
                        Personal Training Uden en Schijndel van WE ARE is de
                        nieuwe standaard!
                    </h2>
                    <p className="mt-4 text-lg text-gray-100">
                        WE ARE – your physical and mental personal training is
                        de nieuwe standaard in de wereld van personal training.
                        Op onze locaties in Uden en Schijndel bieden we onze
                        leden een uniek programma waarmee ze in zeer korte tijd
                        de transformatie van hun leven maken. Hierbij is onze
                        filosofie een belangrijk onderdeel: het lichaam zal gaan
                        waar de ‘mind’ kan komen! Om deze reden volgen onze
                        leden een tweedelig programma: fysiek en mentaal! Dus
                        wanneer je graag wilt afvallen, gespierder wilt worden
                        of fitter zonder een jojo effect, dan is Personal
                        training van WE ARE in Uden of Schijndel de oplossing!
                    </p>
                    <a
                        href={route("twelve-week-program")}
                        className="mt-12 uppercase inline-flex items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-black hover:text-white bg-we-are-yellow hover:bg-we-are-purple focus:outline-none focus:ring-2 focus:ring-offset-2"
                    >
                        Meer informatie
                    </a>
                </div>

                <div className="flex justify-center items-center max-w-4xl mx-auto my-8">
                    <img
                        src="/assets/nieuwe-standaard-2.jpg"
                        className="rounded-2xl"
                    />
                </div>
                {/* Our promises */}
                {/* <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:py-8 lg:px-8">
                    <div className="max-w-3xl mx-auto text-center">
                        <p className="mt-2 text-4xl text-white font-custom italic font-bold uppercase">
                            Onze <span className="text-we-are-yellow">5</span>{" "}
                            beloftes
                        </p>
                        <p className="mt-4 text-lg text-gray-100">
                            Dit is wat jij jou zullen beloven zolang je bij ons
                            komt sporten. Wij zullen je blijven begeleiden in
                            het behalen van jouw (nieuwe) doelen.
                        </p>
                    </div>
                    <dl className="mt-12 space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 lg:grid-cols-3 lg:gap-x-8">
                        {promises.map((promise) => (
                            <div key={promise.name} className="relative">
                                <dt>
                                    <CheckIcon
                                        className="absolute h-10 w-10 text-green-500"
                                        aria-hidden="true"
                                    />
                                    <p className="ml-12 text-lg xs:leading-8 sm:leading-8 md:leading-8 lg:leading-8 text-gray-100">
                                        {promise.name}
                                    </p>
                                </dt>
                            </div>
                        ))}
                    </dl>
                </div> */}
                <Promises />
                <div className="flex justify-center items-center max-w-4xl mx-auto my-8">
                    <img
                        src="/assets/nieuwe-standaard.jpg"
                        className="rounded-2xl"
                    />
                </div>
                <Listen />
                {/* Our team */}
                <div className="mx-auto max-w-7xl">
                    <div className="text-center max-w-7xl mx-auto">
                        <h2 className="block text-white font-custom italic font-bold uppercase xl:inline  xs:text-4xl sm:text-4xl md:text-4xl lg:text-5xl">
                            Who
                        </h2>
                        <p className="text-8xl tracking-tight font-extrabold italic uppercase font-custom text-white sm:text-8xl md:text-8xl lg:text-8xl xl:text-8xl">
                            <span className="text-we-are-yellow">We </span>
                            <span className="text-we-are-purple">Are</span>
                        </p>
                        <p className="text-lg text-gray-100 sm:max-w-xl max-w-4xl mx-auto">
                            Ons team van specialistische Personal Trainers staan
                            voor je klaar in Uden en Schijndel! Zij zijn
                            allemaal gediplomeerde trainers die het uiterste uit
                            jouw avontuur weten te halen met behulp van
                            effectieve voeding,- en trainingsschema’s.
                        </p>
                    </div>
                    <ul
                        role="list"
                        className="lg:mt-24 md:mt-12 sm:mt-12 xs:mt-12 space-y-12 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 sm:space-y-0 lg:grid-cols-3 lg:gap-x-8"
                    >
                        {people.map((person) => (
                            <li key={person.name} className="ml-0 pl-0">
                                <div className="space-y-4">
                                    <div className="aspect-w-3 aspect-h-2">
                                        <picture>
                                            <source
                                                style={
                                                    person.name ===
                                                        "Tim - Personal Trainer Uden" ||
                                                    person.name ===
                                                        "Jori - Personal Trainer Uden"
                                                        ? { height: "260px" }
                                                        : {}
                                                }
                                                srcSet={person.imageUrlWebp}
                                                width="384"
                                                height={
                                                    person.name !==
                                                        "Tim - Personal Trainer Uden" &&
                                                    person.name !==
                                                        "Jori - Personal Trainer Uden"
                                                        ? 256
                                                        : 260
                                                }
                                                type="image/webp"
                                                alt="Sportinstructeur personal trainers WE ARE"
                                                className="object-cover shadow-lg rounded-lg"
                                            />
                                            <source
                                                style={
                                                    person.name ===
                                                        "Tim - Personal Trainer Uden" ||
                                                    person.name ===
                                                        "Jori - Personal Trainer Uden"
                                                        ? { height: "260px" }
                                                        : {}
                                                }
                                                srcSet={person.imageUrl}
                                                width="384"
                                                height={
                                                    person.name !==
                                                        "Tim - Personal Trainer Uden" &&
                                                    person.name !==
                                                        "Jori - Personal Trainer Uden"
                                                        ? 256
                                                        : 260
                                                }
                                                type="image/jpeg"
                                                alt="Sportinstructeur personal trainers WE ARE"
                                                className="object-cover shadow-lg rounded-lg"
                                            />
                                            <img
                                                style={
                                                    person.name ===
                                                        "Tim - Personal Trainer Uden" ||
                                                    person.name ===
                                                        "Jori - Personal Trainer Uden"
                                                        ? { height: "260px" }
                                                        : {}
                                                }
                                                src={person.imageUrl}
                                                width="384"
                                                height={
                                                    person.name !==
                                                        "Tim - Personal Trainer Uden" &&
                                                    person.name !==
                                                        "Jori - Personal Trainer Uden"
                                                        ? 256
                                                        : 260
                                                }
                                                alt="Sportinstructeur personal trainers WE ARE"
                                                className="object-cover shadow-lg rounded-lg"
                                            />
                                        </picture>
                                    </div>

                                    <div className="space-y-2">
                                        <div className="text-lg text-center leading-6 font-medium space-y-1">
                                            <h3 className="text-white">
                                                {person.name}
                                            </h3>
                                            <p className="text-we-are-yellow">
                                                {person.role}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};
